import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  ControlLabel,
  FormGroup,
  HelpBlock
  // FormControl,
} from 'react-bootstrap';
import AutoCompleteInput from '../../elements/FormBuilder/AutoCompleteInput'

const TaxLabelInput = ({ onChange, value, options, errors }) => {
  return(
    <FormGroup
      validationState={
        errors.label && !value ? "error" : null
      }>
      <FormattedMessage id='ids_taxName'>{label =>
        <div>
          <ControlLabel>
            {label}
          </ControlLabel>
          <AutoCompleteInput
            placeholder={label}
            value={value}
            onValueChange={onChange}
            options={options}
            />
        </div>
      }
    </FormattedMessage>
      {errors.label && !value && (
        <HelpBlock>
          <FormattedMessage
            id="ids_enterTaxeName"/>
        </HelpBlock>
      )}
    </FormGroup>
  )
}

export default TaxLabelInput;
